// Note: Remove require packages in package.json if exported as external modules
import axiosAuthHttp from './axios-auth-http';

const bindHandlers = (requester, handlers) => {
  if (handlers == null) {
    return;
  }

  const successHandlerNamesMap = {
    request: 'onRequestSuccess',
    response: 'onResponseSuccess',
  };

  // eslint-disable-next-line
  for (const interceptorTypeName in successHandlerNamesMap) {
    const handler = handlers[successHandlerNamesMap[interceptorTypeName]];

    requester.interceptors[interceptorTypeName].use(
      (success) => {
        if (handler != null) {
          handler(success);
        }

        return success;
      },
      (error) => {
        if (handlers.onError != null) {
          try {
            handlers.onError(error);
          } catch (handlerError) {
            // UI error formatting must never replace the original HTTP failure.
            // The caller still needs the Axios config/response for diagnostics.
            console.error('[http] Error handler failed:', handlerError);
          }
        }

        return Promise.reject(error);
      }
    );
  }
};

const getTokenOptions = (requesterType) => {
  switch (requesterType) {
    case 'CMS_WEB_SERVICE':
      return {
        name: window.processEnv.VUE_APP_API_KEY_TOKEN_NAME,
        salt: window.processEnv.VUE_APP_API_KEY_TOKEN_SALT,
        ttl: window.processEnv.VUE_APP_API_KEY_TOKEN_TTL,
        body: {
          API_KEY: window.processEnv.VUE_APP_API_KEY_VALUE,
        },
      };
    case 'CRM_WEB_SERVICE':
      return {
        name: window.processEnv.VUE_APP_API_KEY_TOKEN_NAME,
        salt: window.processEnv.VUE_APP_API_KEY_TOKEN_SALT,
        ttl: window.processEnv.VUE_APP_API_KEY_TOKEN_TTL,
        body: {
          API_KEY: window.processEnv.VUE_APP_API_KEY_VALUE,
        },
      };
    default:
      return null;
  }
};

class HttpUtils {
  // eslint-disable-next-line object-curly-newline
  createRequester({ baseUrl, headers, requesterType, onRequestSuccess, onResponseSuccess, onError }) {
    const requester = axiosAuthHttp.create({
      baseUrl,
      headers,
      token: getTokenOptions(requesterType),
    });

    bindHandlers(requester, {
      onRequestSuccess,
      onResponseSuccess,
      onError,
    });

    return requester;
  }
}

export default new HttpUtils();
